import { render, staticRenderFns } from "./PendencyDisapproval.vue?vue&type=template&id=920fe4f6"
import script from "./PendencyDisapproval.vue?vue&type=script&lang=js"
export * from "./PendencyDisapproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports